// Merkezi firma / medya / kampanya yapılandırması.
// Gerçek marka medyaları (logo, çalışma fotoğrafları ve video) burada tanımlanır.

export const SITE_URL = ""; // Gerçek alan adı tanımlanınca canonical/og:url üretilir (ör. "https://gulayonar.com")

export const brand = {
  name: "gülaYonar",
  tagline: "Hair • Beauty • Make Up",
  storyTitle: "New York'tan Bursa'ya uzanan 33 yıllık saç tasarımı tecrübesi.",
  location: "ODUNLUK • NİLÜFER / BURSA",
};

export const contact = {
  phoneDisplay: "0541 347 67 84",
  phoneHref: "tel:+905413476784",
  whatsappNumber: "905413476784",
  instagramUrl: "https://www.instagram.com/gulayonar_hairbeauty/",
  instagramHandle: "gulayonar_hairbeauty",
  address:
    "Odunluk Mahallesi, Akpınar Caddesi No: 13BA, Zorlu Plaza, Kat: 1, Daire: 2, Nilüfer / Bursa",
};

export function getMapsUrl(address: string): string {
  return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(address);
}

export const campaign = {
  title: "Profesyonel cilt bakımında %25 indirim",
  subtitle:
    "Eylül ayı boyunca geçerlidir. Güncel ücret ve kampanya ayrıntılarını salonumuzdan öğrenebilirsiniz.",
  endDate: "2026-09-30",
  // Europe/Istanbul (UTC+3, yaz saati uygulanmaz)
  endDateTime: "2026-09-30T23:59:59+03:00",
  imageFile: "GY-K01-eylul-kampanyasi.jpg",
  // Kampanya görseli henüz yüklenmediği için geçici görsel kullanılıyor.
  image:
    "https://readdy.ai/api/search-image?query=Elegant%20spa%20skincare%20flat%20lay%20with%20hydrating%20serum%20bottles%20cream%20jars%20and%20soft%20natural%20botanicals%20on%20a%20warm%20ivory%20background%2C%20champagne%20gold%20accents%2C%20soft%20diffused%20light%2C%20premium%20beauty%20salon%20editorial%20photography%2C%20clean%20minimal%20composition%2C%20high%20detail&width=1200&height=900&seq=gulayonar-kampanya-01&orientation=landscape",
};

export function isCampaignActive(now: Date = new Date()): boolean {
  return now.getTime() <= new Date(campaign.endDateTime).getTime();
}

// Gerçek marka medyaları — yüklenen logo, çalışma fotoğrafları ve video.
export const media = {
  logoFile: "GY-LOGO.jpg",
  logo: "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/b4eac241-c94c-4e68-9a5f-60ba474dcd65_compressed_res17.webp",
  heroMain:
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/64ce2725-e0d9-4798-b62a-1e39212a16d4_compressed_res11.webp",
  heroDetail:
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/14329d38-8576-4029-9405-cde3e03e6103_compressed_res2.webp",
  bridal: [
    // Zarif gelin topuzu (duvak + aksesuar)
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/14329d38-8576-4029-9405-cde3e03e6103_compressed_res2.webp",
    // Hacimli gelin topuzu
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/e2e3c7dd-603b-49ea-a67d-552a9a9e6f57_compressed_res10.webp",
    // Özel gün saç tasarımı (helezon topuz)
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/cb6ef7d2-6da0-483c-bdd4-1ffc21bb8658_compressed_res13.webp",
  ],
  gallery: [
    // Koyu renk uzun dalgalı saç
    "https://public.readdy.ai/ai/img_res/edited_4d9c0a507f51b7cc5435dbd287d0385e_be7d7f5c.jpg",
    // Balyaj dalgalı saç
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/64ce2725-e0d9-4798-b62a-1e39212a16d4_compressed_res11.webp",
    // Kıvırcık perma
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/1bbc9a54-d571-467c-b936-b5f22146f88e_compressed_res7.webp",
    // Bakır tonlu renkli saç
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/16b50f7c-b07a-4e5f-a87c-fec41589cec7_compressed_res5.webp",
    // Duvak ve aksesuarlı zarif gelin topuzu
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/14329d38-8576-4029-9405-cde3e03e6103_compressed_res2.webp",
    // Işıltılı hacimli gelin topuzu
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/e2e3c7dd-603b-49ea-a67d-552a9a9e6f57_compressed_res10.webp",
    // Çiçek aksesuarlı gelin topuzu
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/7e3c7017-ee58-4d63-8900-d08d8b0a5d47_compressed_res8.webp",
    // Helezon özel gün topuzu
    "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/cb6ef7d2-6da0-483c-bdd4-1ffc21bb8658_compressed_res13.webp",
  ],
  campaignVideo: "",
  videoHair: {
    file: "GY-V01-sac-donusumu.mp4",
    src: "https://storage.helloreaddy.io/project_files/a4339e9a-5636-4cdc-9558-71575d28ef0f/9ca84108-38c7-4485-8a0d-a584d65ff6a0_v1.mp4",
    poster:
      "https://public.readdy.ai/ai/img_res/edited_4d9c0a507f51b7cc5435dbd287d0385e_be7d7f5c.jpg",
  },
  videoG5: {
    file: "GY-V02-g5-bakimi.mp4",
    // G5 videosu henüz yüklenmediği için zarif önizleme gösteriliyor.
    src: "",
    poster:
      "https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/c6d29b7f7b77703bd9f2461e99d3b940.png",
  },
};